import { CuePointMetadataProperties } from '../model/CuePointMetadataProperties';
import {
  AdMetadata,
  AudioSweeperMetadata,
  AudioTrackMetadata,
  SweeperType,
  TritonStreamSidebandMetadata,
} from '../model/TritonStreamSidebandMetadata';

export const SidebandMetadataUtil = {
  buildTrackMetadata: (metadata: TritonStreamSidebandMetadata): AudioTrackMetadata => {
    const cuePointData = metadata.cuePointParameters;
    return {
      trackID: cuePointData[CuePointMetadataProperties.TRACK_ID],
      trackDisplayTitle: cuePointData[CuePointMetadataProperties.TRACK_DISPLAY_TITLE],
      trackDisplayDurationMs: Number(cuePointData[CuePointMetadataProperties.TRACK_DISPLAY_DURATION]),
      trackAlbumName: cuePointData[CuePointMetadataProperties.TRACK_ALBUM_NAME],
      trackAlbumYear: cuePointData[CuePointMetadataProperties.TRACK_ALBUM_YEAR],
      trackAlbumPublisher: cuePointData[CuePointMetadataProperties.TRACK_ALBUM_PUBLISHER],
      trackArtistName: cuePointData[CuePointMetadataProperties.TRACK_ARTIST_NAME],
      trackCoverURL: cuePointData[CuePointMetadataProperties.TRACK_COVER_URL],
    };
  },
  buildSweeperMetadata: (metadata: TritonStreamSidebandMetadata): AudioSweeperMetadata => {
    const cuePointData = metadata.cuePointParameters;
    return {
      sweeperId: cuePointData[CuePointMetadataProperties.SWEEPER_ID],
      sweeperType: getSweepertype(cuePointData[CuePointMetadataProperties.SWEEPER_TYPE]),
    };
  },

  buildAdMetadata: (metadata: TritonStreamSidebandMetadata): AdMetadata => {
    const cuePointData = metadata.cuePointParameters;
    return {
      adId: cuePointData[CuePointMetadataProperties.AD_ID],
      adTitle: cuePointData[CuePointMetadataProperties.AD_DISPLAY_TITLE],
      adDurationMs: Number(cuePointData[CuePointMetadataProperties.AD_DISPLAY_DURATION]),
      vastInline: cuePointData[CuePointMetadataProperties.AD_VAST_DOCUMENT],
      vastRemote: cuePointData[CuePointMetadataProperties.AD_VAST_DOCUMENT_URL],
    };
  },
};

function getSweepertype(type?: string): SweeperType | undefined {
  switch (type) {
    case CuePointMetadataProperties.SWEEPER_TYPE_VALUE_SWEEPER:
      return SweeperType.SWEEPER;
    case CuePointMetadataProperties.SWEEPER_TYPE_VALUE_BUMPER:
      return SweeperType.BUMPER;
    case CuePointMetadataProperties.SWEEPER_TYPE_VALUE_PROMO:
      return SweeperType.PROMO;
    case CuePointMetadataProperties.SWEEPER_TYPE_VALUE_STATION_ID:
      return SweeperType.STATION_ID;
    case CuePointMetadataProperties.SWEEPER_TYPE_VALUE_LINER:
      return SweeperType.LINER;
    case CuePointMetadataProperties.SWEEPER_TYPE_VALUE_JINGLE:
      return SweeperType.JINGLE;
    default:
      return undefined;
  }
}
